import { useMutation } from '@tanstack/react-query';
import { AxiosError } from 'axios';

import { ApiBasket, updateBasket } from 'src/api/basketService';
import { syncBasket } from 'src/utils/sync-basket';

import { queryRetry } from '../query-retry';

export const useUpdateBasket = () =>
    useMutation<
        ApiBasket,
        AxiosError,
        { basketId: string; basketData: Partial<ApiBasket>; updatedAt: string }
    >({
        mutationFn: ({ basketId, basketData, updatedAt }) =>
            updateBasket(basketId, basketData, updatedAt),
        retry: queryRetry,
        onSuccess: (basket) => {
            syncBasket(basket);
        },
    });
